import type { IdeaSource } from './types';

/** Ideenbuch 41–50: stews, quick pasta, bowls and German classics. */
export const IDEAS_5: IdeaSource[] = [
  {
    id: 'pea-soup-sausages',
    minutes: 50,
    tags: ['kids'],
    de: {
      title: 'Erbsensuppe mit Würstchen',
      ingredients: [
        '500 g TK-Erbsen',
        '3 Kartoffeln',
        '2 Möhren',
        '1 Zwiebel',
        '1 l Gemüsebrühe',
        '4 Wiener Würstchen',
        '1 Prise Majoran',
      ],
      steps: [
        'Kartoffeln, Möhren und Zwiebel schälen, würfeln und in etwas Öl andünsten.',
        'Brühe und Erbsen dazugeben und 25 Minuten köcheln lassen.',
        'Die Hälfte der Suppe pürieren, mit Majoran, Salz und Pfeffer abschmecken.',
        'Würstchen in Scheiben schneiden und 5 Minuten in der Suppe erwärmen.',
      ],
      kidsTip: 'Würstchen extra servieren, dann kann jeder selbst schnippeln.',
    },
    en: {
      title: 'Pea soup with sausages',
      ingredients: [
        '500 g frozen peas',
        '3 potatoes',
        '2 carrots',
        '1 onion',
        '1 l vegetable stock',
        '4 frankfurters',
        '1 pinch marjoram',
      ],
      steps: [
        'Peel and dice the potatoes, carrots and onion and soften them in a little oil.',
        'Add the stock and peas and simmer for 25 minutes.',
        'Blend half of the soup and season with marjoram, salt and pepper.',
        'Slice the sausages and warm them in the soup for 5 minutes.',
      ],
      kidsTip: 'Serve the sausages separately so everyone can cut their own.',
    },
  },
  {
    id: 'maultaschen-broth',
    minutes: 20,
    tags: ['kids'],
    de: {
      title: 'Maultaschen in Brühe',
      ingredients: [
        '600 g Maultaschen mit Fleischfüllung (Kühlregal)',
        '1,5 l Gemüsebrühe',
        '2 Möhren',
        '1 Stange Lauch',
        'Schnittlauch',
      ],
      steps: [
        'Möhren in Scheiben, Lauch in Ringe schneiden.',
        'Brühe aufkochen und das Gemüse 8 Minuten darin garen.',
        'Maultaschen hineinlegen und 8 Minuten ziehen lassen, nicht kochen.',
        'Mit Schnittlauch bestreut servieren.',
      ],
      kidsTip: 'Maultaschen halbieren – dann passen sie auf den Löffel.',
    },
    en: {
      title: 'Maultaschen in broth',
      ingredients: [
        '600 g maultaschen with meat filling (chilled)',
        '1.5 l vegetable stock',
        '2 carrots',
        '1 leek',
        'Chives',
      ],
      steps: [
        'Slice the carrots and cut the leek into rings.',
        'Bring the stock to the boil and cook the vegetables in it for 8 minutes.',
        'Add the maultaschen and let them steep for 8 minutes without boiling.',
        'Serve sprinkled with chives.',
      ],
      kidsTip: 'Halve the maultaschen so they fit on a spoon.',
    },
  },
  {
    id: 'salmon-cream-pasta',
    minutes: 25,
    tags: [],
    de: {
      title: 'Pasta mit Lachs-Sahne-Soße',
      ingredients: [
        '400 g Tagliatelle',
        '250 g Lachsfilet ohne Haut',
        '200 g Sahne',
        '1 Zitrone',
        '1 Knoblauchzehe',
        '1 EL Butter',
        'Dill',
      ],
      steps: [
        'Tagliatelle nach Packung kochen.',
        'Lachs würfeln und mit dem Knoblauch in Butter 3 Minuten anbraten.',
        'Sahne und etwas Zitronensaft dazugeben und 3 Minuten köcheln lassen.',
        'Mit Salz, Pfeffer und Dill abschmecken und mit den Nudeln mischen.',
      ],
      kidsTip: 'Dill erst am Tisch darüber – nicht jeder mag ihn.',
    },
    en: {
      title: 'Pasta with salmon cream sauce',
      ingredients: [
        '400 g tagliatelle',
        '250 g skinless salmon fillet',
        '200 g cream',
        '1 lemon',
        '1 clove garlic',
        '1 tbsp butter',
        'Dill',
      ],
      steps: [
        'Cook the tagliatelle as the packet says.',
        'Dice the salmon and fry with the garlic in the butter for 3 minutes.',
        'Add the cream and a little lemon juice and simmer for 3 minutes.',
        'Season with salt, pepper and dill and toss with the pasta.',
      ],
      kidsTip: 'Dill on at the table – not everyone likes it.',
    },
  },
  {
    id: 'tray-chicken',
    minutes: 55,
    tags: ['kids'],
    de: {
      title: 'Blech-Hähnchen mit Kartoffeln und Möhren',
      ingredients: [
        '600 g Hähnchenbrust',
        '800 g Kartoffeln',
        '500 g Möhren',
        '1 rote Zwiebel',
        '3 EL Olivenöl',
        '1 EL Honig',
        '1 TL Thymian',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen.',
        'Kartoffeln und Möhren in Spalten schneiden, Zwiebel in Streifen.',
        'Mit 2 EL Öl, Thymian und Salz mischen und 20 Minuten backen.',
        'Hähnchen in große Stücke schneiden, mit restlichem Öl und Honig mischen, dazulegen und 20 Minuten weiterbacken.',
      ],
      kidsTip: 'Ein Blech, wenig Abwasch.',
    },
    en: {
      title: 'Tray-baked chicken with potatoes and carrots',
      ingredients: [
        '600 g chicken breast',
        '800 g potatoes',
        '500 g carrots',
        '1 red onion',
        '3 tbsp olive oil',
        '1 tbsp honey',
        '1 tsp thyme',
      ],
      steps: [
        'Heat the oven to 200 °C.',
        'Cut the potatoes and carrots into wedges and the onion into strips.',
        'Mix with 2 tbsp oil, thyme and salt and bake for 20 minutes.',
        'Cut the chicken into large pieces, mix with the rest of the oil and the honey, add to the tray and bake for another 20 minutes.',
      ],
      kidsTip: 'One tray, little washing-up.',
    },
  },
  {
    id: 'tortellini-ham-cream',
    minutes: 20,
    tags: ['kids'],
    de: {
      title: 'Tortellini mit Schinken-Sahne-Soße',
      ingredients: [
        '500 g Tortellini (Kühlregal)',
        '150 g gekochter Schinken',
        '200 g Sahne',
        '150 g TK-Erbsen',
        '50 g Parmesan, gerieben',
        '1 EL Butter',
      ],
      steps: [
        'Tortellini nach Packung kochen.',
        'Schinken würfeln und in Butter 2 Minuten anbraten.',
        'Sahne und Erbsen dazugeben und 5 Minuten köcheln lassen.',
        'Parmesan einrühren, abschmecken und mit den Tortellini mischen.',
      ],
      kidsTip: 'Ein Klassiker, der fast immer leer gegessen wird.',
    },
    en: {
      title: 'Tortellini with ham and cream sauce',
      ingredients: [
        '500 g tortellini (chilled)',
        '150 g cooked ham',
        '200 g cream',
        '150 g frozen peas',
        '50 g Parmesan, grated',
        '1 tbsp butter',
      ],
      steps: [
        'Cook the tortellini as the packet says.',
        'Dice the ham and fry in the butter for 2 minutes.',
        'Add the cream and peas and simmer for 5 minutes.',
        'Stir in the Parmesan, season and toss with the tortellini.',
      ],
      kidsTip: 'A classic that nearly always comes back empty.',
    },
  },
  {
    id: 'peanut-bowl',
    minutes: 30,
    tags: ['veggie'],
    de: {
      title: 'Reis-Bowl mit Erdnusssoße',
      ingredients: [
        '250 g Reis',
        '200 g Tofu',
        '2 Möhren',
        '1 Gurke',
        '1 Avocado',
        '3 EL Erdnussbutter',
        '3 EL Sojasoße',
        '1 Limette',
        '1 EL Öl',
      ],
      steps: [
        'Reis nach Packung kochen.',
        'Tofu würfeln und in Öl 8 Minuten knusprig braten.',
        'Möhren raspeln, Gurke und Avocado in Scheiben schneiden.',
        'Erdnussbutter, Sojasoße, Limettensaft und 4 EL warmes Wasser glatt rühren.',
        'Alles in Schalen anrichten und mit der Soße beträufeln.',
      ],
      kidsTip: 'Jeder stellt seine Bowl selbst zusammen.',
    },
    en: {
      title: 'Rice bowl with peanut sauce',
      ingredients: [
        '250 g rice',
        '200 g tofu',
        '2 carrots',
        '1 cucumber',
        '1 avocado',
        '3 tbsp peanut butter',
        '3 tbsp soy sauce',
        '1 lime',
        '1 tbsp oil',
      ],
      steps: [
        'Cook the rice as the packet says.',
        'Dice the tofu and fry in the oil for 8 minutes until crisp.',
        'Grate the carrots and slice the cucumber and avocado.',
        'Stir the peanut butter, soy sauce, lime juice and 4 tbsp warm water until smooth.',
        'Arrange everything in bowls and drizzle with the sauce.',
      ],
      kidsTip: 'Everyone builds their own bowl.',
    },
  },
  {
    id: 'courgette-fritters',
    minutes: 35,
    tags: ['veggie'],
    de: {
      title: 'Zucchinipuffer mit Joghurtdip',
      ingredients: [
        '2 Zucchini',
        '2 Eier',
        '4 EL Mehl',
        '50 g Parmesan, gerieben',
        '250 g Joghurt',
        '1 Knoblauchzehe',
        '4 EL Öl',
      ],
      steps: [
        'Zucchini grob raspeln, salzen, 10 Minuten ziehen lassen und kräftig ausdrücken.',
        'Mit Eiern, Mehl und Parmesan vermengen.',
        'Kleine Puffer in Öl von jeder Seite 3 Minuten braten.',
        'Joghurt mit Knoblauch und Salz verrühren und dazu servieren.',
      ],
      kidsTip: 'Gutes Versteck für Gemüse – sie schmecken wie Kartoffelpuffer.',
    },
    en: {
      title: 'Courgette fritters with yoghurt dip',
      ingredients: [
        '2 courgettes',
        '2 eggs',
        '4 tbsp flour',
        '50 g Parmesan, grated',
        '250 g yoghurt',
        '1 clove garlic',
        '4 tbsp oil',
      ],
      steps: [
        'Coarsely grate the courgettes, salt them, leave for 10 minutes and squeeze out well.',
        'Mix with the eggs, flour and Parmesan.',
        'Fry small fritters in the oil for 3 minutes on each side.',
        'Stir the yoghurt with garlic and salt and serve with them.',
      ],
      kidsTip: 'A good hiding place for vegetables – they taste like potato fritters.',
    },
  },
  {
    id: 'mustard-eggs',
    minutes: 30,
    tags: ['veggie'],
    de: {
      title: 'Senfeier mit Kartoffeln',
      ingredients: [
        '8 Eier',
        '1 kg Kartoffeln',
        '2 EL Butter',
        '2 EL Mehl',
        '500 ml Gemüsebrühe',
        '100 g Sahne',
        '3 EL mittelscharfer Senf',
        'Schnittlauch',
      ],
      steps: [
        'Kartoffeln schälen und in Salzwasser 20 Minuten kochen.',
        'Eier 8 Minuten hart kochen, abschrecken und pellen.',
        'Butter schmelzen, Mehl einrühren, Brühe und Sahne dazugießen und 5 Minuten köcheln lassen.',
        'Senf einrühren, abschmecken, Eier halbieren und in die Soße legen, mit Schnittlauch servieren.',
      ],
      kidsTip: 'Milder Senf, und die Soße wird kinderleicht.',
    },
    en: {
      title: 'Eggs in mustard sauce with potatoes',
      ingredients: [
        '8 eggs',
        '1 kg potatoes',
        '2 tbsp butter',
        '2 tbsp flour',
        '500 ml vegetable stock',
        '100 g cream',
        '3 tbsp medium mustard',
        'Chives',
      ],
      steps: [
        'Peel the potatoes and boil in salted water for 20 minutes.',
        'Hard-boil the eggs for 8 minutes, cool and peel.',
        'Melt the butter, stir in the flour, pour in the stock and cream and simmer for 5 minutes.',
        'Stir in the mustard, season, halve the eggs, lay them in the sauce and serve with chives.',
      ],
      kidsTip: 'Use mild mustard and the sauce becomes child’s play.',
    },
  },
  {
    id: 'koenigsberger-klopse',
    minutes: 50,
    tags: [],
    de: {
      title: 'Königsberger Klopse',
      ingredients: [
        '500 g gemischtes Hackfleisch',
        '1 Brötchen vom Vortag',
        '1 Ei',
        '1 Zwiebel, fein gewürfelt',
        '1 l Gemüsebrühe',
        '2 EL Butter',
        '2 EL Mehl',
        '100 g Sahne',
        '2 EL Kapern',
        '1 kg Kartoffeln',
      ],
      steps: [
        'Kartoffeln schälen und 20 Minuten in Salzwasser kochen.',
        'Brötchen einweichen, ausdrücken und mit Hack, Ei, Zwiebel, Salz und Pfeffer verkneten, zwölf Klopse formen.',
        'Klopse in siedender Brühe 15 Minuten ziehen lassen und herausnehmen.',
        'Butter schmelzen, Mehl einrühren, mit 600 ml Brühe und der Sahne aufgießen und 5 Minuten köcheln lassen.',
        'Kapern und etwas Zitronensaft einrühren, Klopse darin erwärmen.',
      ],
      kidsTip: 'Kapern nur in die Hälfte der Soße.',
    },
    en: {
      title: 'Königsberg meatballs in caper sauce',
      ingredients: [
        '500 g mixed mince',
        '1 stale bread roll',
        '1 egg',
        '1 onion, finely diced',
        '1 l vegetable stock',
        '2 tbsp butter',
        '2 tbsp flour',
        '100 g cream',
        '2 tbsp capers',
        '1 kg potatoes',
      ],
      steps: [
        'Peel the potatoes and boil in salted water for 20 minutes.',
        'Soak the roll, squeeze it out and knead with the mince, egg, onion, salt and pepper, then shape twelve meatballs.',
        'Poach the meatballs in simmering stock for 15 minutes and take them out.',
        'Melt the butter, stir in the flour, pour in 600 ml of the stock and the cream and simmer for 5 minutes.',
        'Stir in the capers and a little lemon juice and warm the meatballs in the sauce.',
      ],
      kidsTip: 'Capers in only half of the sauce.',
    },
  },
  {
    id: 'kaiserschmarrn',
    minutes: 30,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Kaiserschmarrn',
      ingredients: [
        '4 Eier',
        '250 ml Milch',
        '150 g Mehl',
        '2 EL Zucker',
        '1 Prise Salz',
        '3 EL Butter',
        'Puderzucker',
        '1 Glas Apfelmus',
      ],
      steps: [
        'Eier trennen, Eiweiß mit Salz steif schlagen.',
        'Eigelb, Milch, Mehl und Zucker glatt rühren, Eischnee unterheben.',
        'Teig in Butter 4 Minuten backen, wenden und mit zwei Gabeln in Stücke reißen.',
        'Weitere 3 Minuten braten, mit Puderzucker bestäuben und mit Apfelmus servieren.',
      ],
      kidsTip: 'Kinder dürfen den Schmarrn zerrupfen.',
    },
    en: {
      title: 'Kaiserschmarrn (shredded pancake)',
      ingredients: [
        '4 eggs',
        '250 ml milk',
        '150 g flour',
        '2 tbsp sugar',
        '1 pinch salt',
        '3 tbsp butter',
        'Icing sugar',
        '1 jar apple sauce',
      ],
      steps: [
        'Separate the eggs and whisk the whites with the salt until stiff.',
        'Stir the yolks, milk, flour and sugar until smooth and fold in the egg whites.',
        'Cook the batter in the butter for 4 minutes, turn it and tear into pieces with two forks.',
        'Fry for another 3 minutes, dust with icing sugar and serve with apple sauce.',
      ],
      kidsTip: 'Kids can do the tearing.',
    },
  },
];
